import { Suspense } from 'react';
import { SimProductActionSelectButton } from './SimProductActionSelectButton';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { ActionsToolbar } from 'products/common/actions/ActionsToolbar';

export const SimProductActionToolbar = () => {
  const { t } = useTranslation();
  return (
    <ActionsToolbar>
      <Suspense
        fallback={
          <Button color="secondary" endIcon={<ArrowDropDownIcon />} disabled>
            {t('products.sim.actions.action')}
          </Button>
        }
      >
        <SimProductActionSelectButton />
      </Suspense>
    </ActionsToolbar>
  );
};
